'use client';

import clsx from 'clsx';
import { FC, PropsWithChildren, useEffect, useRef, useState } from 'react';

export const SubmenuWrapper: FC<PropsWithChildren> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [tmpClose, setTmpClose] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const handleClick = (event: MouseEvent) => {
      // Only proceed if the event target is a link or a descendant of a link
      const target = event.target as HTMLElement;
      const isLink = target.closest('a');
      if (!isLink) {
        return;
      }
      setTmpClose(true);
      setTimeout(() => {
        if (isMounted) {
          setTmpClose(false);
        }
      }, 100);
    };

    if (ref.current) {
      ref.current.addEventListener('click', handleClick);
    }

    return () => {
      isMounted = false;
      if (ref.current) {
        ref.current.removeEventListener('click', handleClick);
      }
    };
  }, []);

  return (
    <div
      className={clsx(
        'pointer-events-none fixed top-16 left-0 z-header h-full w-full text-tex-def-tie1 opacity-0 transition-opacity duration-200',
        {
          'group-focus-within/header-link:opacity-100 group-hover/header-link:opacity-100': !tmpClose,
          ['hidden']: tmpClose,
        },
      )}
      ref={ref}
    >
      <div className="c-se--default">
        <div className="z-10 m-auto w-full max-w-6xl -translate-y-2 py-2 transition-transform duration-200 group-focus-within/header-link:pointer-events-auto group-focus-within/header-link:translate-y-0 group-hover/header-link:pointer-events-auto group-hover/header-link:translate-y-0">
          <div className="color-tex-inv-tie1 overflow-hidden rounded-lg border border-bor-neu-mut shadow-elevation-24dp">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
